export const SIZE = [
  'small',
  'regular'
]